import { QueryCache, QueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

// Toast copy for a top-level domain query that fails to load. These messages
// used to be raised by useData's own initial fetch of the four core domains.
// That fetch duplicated the query hooks' fetch and was removed, so the queries
// now own the load-failure surface. Keyed by the query key's only segment, so
// entity-scoped keys like ["tasks", id] don't inherit a collection message.
const LOAD_ERROR_MESSAGES: Record<string, string> = {
  tasks: "Failed to load tasks",
  lists: "Failed to load lists",
  tags: "Failed to load tags",
  filters: "Failed to load filters",
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (_error, query) => {
      // Only the initial load toasts. A background refetch that fails while
      // the user still has data on screen stays silent, matching the previous
      // behaviour where only the mount-time fetch surfaced a toast.
      if (query.state.data !== undefined) return;
      if (query.queryKey.length !== 1) return;
      const message = LOAD_ERROR_MESSAGES[String(query.queryKey[0])];
      if (message) toast.error(message);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
      refetchOnWindowFocus: true,
    },
  },
});
